<template>
    <BreadCrumb PageTitle="Détail de retour" />
    <DetailRetour/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import DetailRetour from "../../components/Retour/DetailRetour.vue";

  
    export default defineComponent({
      name: "DetailRetourPage",
      components: {
        BreadCrumb,
        DetailRetour,
      },
    });
  </script>